module.exports = __webpack_public_path__ + "img/db956fe4f3d2a5114bdaf0a56a3e5d12.svg";